export {
  CloseUpShot,
  type CloseUpShotProps as PhotoCaptureHUDElementsAddDamage2ndShotProps,
} from './CloseUpShot';
